import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import { SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { Call, ProcessStatus } from "@snubes/snubes-types";
import { FC } from "react";
import { StatusColor } from "../../Common/types/StatusColor";
import { StatusChip } from "../../Common/views/StatusChip";
import { useT } from "../../Translation/hooks/useT";
import { TranslationKey } from "../../Translation/types/TranslationKey";

interface Props {
  call: Call;
}

export const CallVoicefileProcessStatusChip: FC<Props> = (props) => {
  const { call } = props;
  const t = useT();
  const status = call.voicefileProcess?.status || "ON_HOLD";
  const { color, label, Icon, isLoading } = STATUS_RECORD[status];

  return (
    <StatusChip
      Icon={Icon}
      label={t(label)}
      color={color}
      isLoading={isLoading}
    />
  );
};

interface StatusRecordValue {
  color: StatusColor;
  label: TranslationKey;
  Icon?: OverridableComponent<SvgIconTypeMap>;
  isLoading?: boolean;
}

const STATUS_RECORD: Record<ProcessStatus, StatusRecordValue> = {
  ON_HOLD: {
    color: "default",
    label: "CallVoicefileProcessStatusChip_Label_OnHold",
    Icon: MicOffIcon,
  },
  PROCESSING: {
    color: "primary",
    label: "CallVoicefileProcessStatusChip_Label_Processing",
    isLoading: true,
  },
  SUCCEEDED: {
    color: "secondary",
    label: "CallVoicefileProcessStatusChip_Label_Succeeded",
    Icon: MicIcon,
  },
  FAILED: {
    color: "error",
    label: "CallVoicefileProcessStatusChip_Label_Failed",
    Icon: MicOffIcon,
  },
  REQUESTED: {
    color: "primary",
    label: "CallVoicefileProcessStatusChip_Label_Requested",
    isLoading: true,
  },
};
